module.exports = "/_next/static/images/know-transfez-collect-793840ad9fb6041633eac9556a3887a0.svg";